module.exports = __webpack_public_path__ + "static/logos/whiteroom_logo--white-f8c49fe22aafe28d73fa67a6f7c0bdf8.svg";